/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
import React, { Component } from 'react';
import {
  Button, ButtonToolbar, Label, Input, FormGroup,
  Modal, ModalBody,
} from 'reactstrap';
import 'react-datepicker/dist/react-datepicker.css';
// import BasicNotification from './Notifications/BasicNotification';

class AssigCaseModalComponent extends Component {
  static defaultProps = {
    title: '',
    message: '',
    colored: false,
    header: false,
    selectedOption: null,
  };

  constructor() {
    super();
    this.state = {
      // _id: null,
      // phones: [
      //   {
      //     code: '',
      //     number: '',
      //   },
      // ],
    };
  }


  render() {
    const {
      // hideFind,
      title,
      hideNewContact,
      onChangeInput, value, isOpen, onSubmitAssign, isRUTValid, onNewContact,
      // disabledIt,
    } = this.props;

    return (
      <div>
        <Modal
          isOpen={isOpen}
          toggle={this.props.toggle}
          className="modal-dialog modal-dialog--success"
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" onClick={this.props.toggle} />
            <h2 className="bold-text label_autofin  modal__title" style={{ fontWeight: 'bold', textAlign: 'left' }}> <strong>{title}</strong></h2>
          </div>
          <form className="form form--horizontal" onSubmit={onSubmitAssign}>
            <ModalBody className='crm-new-case-body'>
              <FormGroup style={{ textAlign: 'left' }}>
                <Label className="label_autofin" for="rut">Ingrese RUT:</Label>
                <Input
                  type="text"
                  name="rut"
                  id="rut"
                  value={value.rut}
                  invalid={!isRUTValid(value.rut)}
                  onChange={onChangeInput('rut')}
                  required
                />
              </FormGroup>
            </ModalBody>
            <ButtonToolbar className="modal__footer crm-new-case-buttons" style={{ justifyContent: 'center' }}>
              <Button className="asignar" onClick={this.props.toggle}>Cancel</Button>{' '}
              <Button
                className="asignar just_this"
                type="submit"
                // hidden={hideFind}
                disabled={!isRUTValid(value.rut) || !value.rut ? true : false}
                id="added"
              >Buscar
              </Button>
              <div>
                <div hidden={hideNewContact}>Contacto no está registrado</div>
                <div hidden={hideNewContact}>¿Desea crearlo?</div>
                <Button
                  className="asignar just_this"
                  style={{ marginTop: '5%' }}
                  type="button"
                  onClick={onNewContact}
                  id="added"
                  hidden={hideNewContact}
                >Crear Contacto
                </Button>
              </div>
            </ButtonToolbar>
          </form>
        </Modal>
      </div>
    );
  }
}

export default AssigCaseModalComponent;
